import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=5e322e5a&scoped=true"
import script from "./Draggable.vue?vue&type=script&lang=js"
export * from "./Draggable.vue?vue&type=script&lang=js"
import style0 from "./Draggable.vue?vue&type=style&index=0&id=5e322e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e322e5a",
  null
  
)

export default component.exports